import { AfterViewInit, Component, Input, OnInit } from '@angular/core';

import { IColumn, IItem } from '@coreui/angular-pro';

@Component({
  selector: 'app-smart-table',
  standalone: false,
  templateUrl: './smart-table.component.html',
  styleUrls: ['./smart-table.component.scss']
})
export class SmartTableComponent implements OnInit{
  @Input() tableData:IItem[] = [];
  @Input() columns: (IColumn | string)[] = []

  // getBadge(status: string) {
  //   switch (status) {
  //     case 'Active':
  //       return 'success'
  //     case 'Inactive':
  //       return 'secondary'
  //     case 'Pending':
  //       return 'warning'
  //     case 'Banned':
  //       return 'danger'
  //     default:
  //       return 'primary'
  //   }
  // }

  getItem(item: any) {
    return Object.keys(item);
  }

  details_visible = Object.create({});

  toggleDetails(item: any) {
    this.details_visible[item] = !this.details_visible[item];
  }

  ngOnInit(): void {

    //this.columns = Object.keys(this.tableData[0]);
  }
}
